export const LearnersManager = {
  id: 'learners-manager',
  showGenericAvatar: true,
  name: "Learner's Manager",
  trainingContact: {
    useLearnerManagers: true,
  },
};

export const CourseAssigner = {
  id: 'course-assigner',
  showGenericAvatar: true,
  name: 'Course Assigner',
  trainingContact: {
    useLearnerAssigner: true,
  },
};

export const CourseCreator = {
  label: 'Course Creator',
};

export const CourseEditor = {
  label: 'Course Editor',
};
